import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';

/**
 * Schema per gestire le traduzioni delle domande.
 */
export const InquiryTypeTranslationSchema = tran
  .object({
    copertina: tran.object({
      // Già gestiti da Backend direttamente
      // titolo: tran.string(),
      // pulsanteAccesso: tran.string(),
      paragrafi: tran.array(
        tran.object({
          titolo: tran.string(),
          corpo: tran.string(),
        }),
      ),
    }),
  })
  .withRoot('TipoDomanda');
